/**
 * Generated by orval v6.12.1 🍺
 * Do not edit manually.
 * Platz API
 * Platz API boi
 * OpenAPI spec version: 2.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  UseMutationOptions,
  MutationFunction,
} from "@tanstack/react-query";
import type { PlatzApiError, GetDefInContextRequest } from ".././model";
import { customInstance } from "../../../axios";
import type { ErrorType, BodyType } from "../../../axios";

export const getDefInContext = (
  getDefInContextRequest: BodyType<GetDefInContextRequest>
) => {
  return customInstance<string[]>({
    url: `/api/simple-defs/location`,
    method: "put",
    headers: { "Content-Type": "application/json" },
    data: getDefInContextRequest,
  });
};

export type GetDefInContextMutationResult = NonNullable<
  Awaited<ReturnType<typeof getDefInContext>>
>;
export type GetDefInContextMutationBody = BodyType<GetDefInContextRequest>;
export type GetDefInContextMutationError = ErrorType<PlatzApiError>;

export const useGetDefInContext = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDefInContext>>,
    TError,
    { data: BodyType<GetDefInContextRequest> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getDefInContext>>,
    { data: BodyType<GetDefInContextRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return getDefInContext(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof getDefInContext>>,
    TError,
    { data: BodyType<GetDefInContextRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
